module.exports = __webpack_public_path__ + "img/huaweilogo_homepage_ar.955b2e87.png";